import React from 'react';
import PropTypes from 'prop-types';
import SortableList from './SortableList';

const SortableComponent = ({ items, onSortEnd }) => (
  <SortableList
    items={items}
    onSortEnd={indexInfo => onSortEnd(indexInfo)}
    useDragHandle
    lockAxis="y"
    useWindowAsScrollContainer
  />
);

SortableComponent.propTypes = {
  items: PropTypes.array,
  onSortEnd: PropTypes.func,
};

export default SortableComponent;



// WEBPACK FOOTER //
// ./library/app/components/Global/Sortable/SortableComponent.js